import React from 'react'
import { withStyles } from '@material-ui/core/styles'

const styles = {
	page: {
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
		minHeight: 1,
	},
}

const Page = ({ children, classes }) => <div className={classes.page}>{children}</div>

export default withStyles(styles)(Page)



// WEBPACK FOOTER //
// ./src/components/Page/Page.js